export const setUserId = (value) => {
  return {
    type: "SET_USER_ID",
    payload: value,
  };
};
